import { render } from "./ContentsVideos.vue?vue&type=template&id=016635b8&scoped=true"
import script from "./ContentsVideos.vue?vue&type=script&lang=js"
export * from "./ContentsVideos.vue?vue&type=script&lang=js"

import "./ContentsVideos.vue?vue&type=style&index=0&id=016635b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016635b8"]])

export default __exports__